/* Dependencies */
import styled, { css } from 'styled-components';

export const ConfigHeader = styled.div.attrs(() => ({
  className: 'CenterConfigHeader',
}))`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;

  height: 60px;
  width: 100%;
`;

export const SaveBtn = styled.div.attrs(() => ({
  className: 'CenterConfigSaveButtonWrapper',
}))`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  margin-top: 30px;
`;

export const ConfigBody = styled.div.attrs(() => ({
  className: 'CenterConfigBody',
}))`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-gap: 30px;

  position: relative;

  ${({ theme }) => theme.breakPoints.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ConfigItem = styled.div.attrs(() => ({
  className: 'CenterConfigItem',
}))`
  .TexterConfig {
    margin: 0;
  }
  .TexterConfig > input {
    border-radius: 20px;
  }
`;

export const Label = styled.div.attrs(() => ({
  className: 'CenterConfigItemLabel',
}))`
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 14px;
  height: 32px;
  margin-bottom: 5px;

  display: flex;
  align-items: center;
  opacity: .5;
`;

export const DeactivateOverlay = styled.div.attrs(() => ({
  className: 'OrganizationConfigDeactivateItems',
}))`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  background-color: #ffffff80;
  z-index: 1;
`;
export const Warning = styled.div.attrs(() => ({
  className: 'OrganizationConfigWarning',
}))`
  color: #F77B5E;
  font-size: 14px;
  margin-top: 20px;
`;

export const StyledModalResultsImage = css`
  margin: 30px auto;
  width: 60px;
  height: auto;
`;

export const WrapperSelecter = styled.div.attrs(() => ({
  className: 'WrapperSelecterCenterConfig',
}))`
  display: block;
  position: relative;
  margin-top: 5px;

  .legoSelecterOptionsList .legoSelecterOptionItem {
    display: flex;
    align-items: center;
  }

  .legoSelecterOptionsContainer {
    margin-top: 0;
    max-height: 200px;
    overflow-y: auto;
    padding: 0;
  }

  .legoSelecterCheckbox[type="checkbox"] {
    position: relative;
    left: 10px
  }

  .legoSelecterOptionIndicator {
    top: 12px;
  }

  .legoSelecterOptionsList {
    margin-top: 0;
  }
`;
